import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-zinc-200">
      <header className="alpha-glass sticky top-0 z-30 h-16 flex items-center px-4 lg:px-8">
        <Link to="/" data-testid="privacy-back-home" className="inline-flex items-center gap-2 text-zinc-300 hover:text-white text-sm"><ArrowLeft size={16} />Voltar ao início</Link>
      </header>

      <main className="max-w-3xl mx-auto px-4 lg:px-8 py-12" data-testid="privacy-page">
        <h1 className="text-3xl sm:text-4xl font-display font-extrabold tracking-tight text-white">Política de Privacidade</h1>
        <p className="text-sm text-zinc-500 mt-2">Alpha Prime Tecnologia — CNPJ 51.061.289/0001-90 · Última atualização: junho de 2026</p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-zinc-300">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Quem somos</h2>
            <p>A Alpha Prime (Alpha Prime Tecnologia) é uma assistência técnica e loja de celulares localizada em Riacho Fundo II, Brasília/DF. Esta política descreve como coletamos, usamos e protegemos os dados pessoais de nossos clientes.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. Dados que coletamos</h2>
            <p>Coletamos apenas os dados necessários para a prestação do serviço, tais como: nome, telefone/WhatsApp, e-mail, CPF, CEP e informações do aparelho (marca, modelo, IMEI e defeito relatado). Esses dados são fornecidos pelo próprio cliente no atendimento, na abertura de ordens de serviço ou em formulários do nosso site.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Como usamos os dados</h2>
            <p>Utilizamos os dados para: identificar o cliente e o aparelho, gerar e acompanhar ordens de serviço, emitir documentos fiscais, prestar suporte e enviar comunicações relacionadas ao serviço (por exemplo, avisos de status do reparo, mensagens de pós-venda e retorno a contatos de interesse). Não vendemos nem alugamos seus dados a terceiros.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Comunicações por WhatsApp</h2>
            <p>Podemos enviar mensagens pelo WhatsApp (via API oficial da Meta) para informar o andamento do seu serviço, realizar contato de pós-venda ou responder a solicitações. Você pode solicitar a interrupção dessas mensagens a qualquer momento, respondendo à conversa ou entrando em contato conosco.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Compartilhamento</h2>
            <p>Podemos compartilhar dados estritamente necessários com prestadores que viabilizam nossos serviços, como plataformas de emissão de nota fiscal, provedores de mensageria (Meta/WhatsApp) e financeiras parceiras (nos casos de venda parcelada no boleto), sempre limitados à finalidade contratada.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Segurança e retenção</h2>
            <p>Adotamos medidas técnicas e administrativas para proteger seus dados, incluindo criptografia de informações sensíveis em nossos sistemas. Mantemos os dados pelo tempo necessário ao cumprimento das finalidades e das obrigações legais aplicáveis.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. Seus direitos (LGPD)</h2>
            <p>Nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você pode solicitar acesso, correção, portabilidade ou exclusão dos seus dados, bem como informações sobre o tratamento realizado. Para exercer esses direitos, entre em contato conosco.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">8. Contato</h2>
            <p>Dúvidas sobre esta política ou sobre seus dados podem ser enviadas para o e-mail <a href="mailto:alphaprimecell@gmail.com" className="text-gold-bright underline">alphaprimecell@gmail.com</a> ou pelo WhatsApp da loja.</p>
          </section>
        </div>
      </main>

      <footer className="border-t border-white/5 py-8 text-center text-xs text-zinc-600">
        © {new Date().getFullYear()} Alpha Prime Tecnologia — Todos os direitos reservados.
      </footer>
    </div>
  );
}
